import endClientSession from './endClientSession';
import { getEntryPoint } from './getEntryPoint';

export const loginEndSessionEntryPoint = ({ dispatch, getState }) => async (nextState, replace, callback) => {
  /* istanbul ignore else -- no else case */
  if (global.BROWSER) {
    endClientSession({ dispatch, getState });
    getEntryPoint();
  }
  callback();
};
